// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      enableFuzzy: false,
	}
};

(function () {  // Add this
	
	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
	};
  
    jQ(window).on('scroll', function() {
      if(!Utils.isMobile()) {
	    jQ('.boost-pfs-search-suggestion-wrapper').hide()
      }
    })
})();  // Add this at the end